import { Code, ConnectError } from '@connectrpc/connect'

export const UPLOAD_STILL_PROCESSING_MESSAGE =
  'Still processing — this file may finish uploading in the background. Check your documents before retrying.'

export const UPLOAD_GENERIC_FAILURE_MESSAGE =
  'There was an error uploading this file. Please try again or contact support.'

// Only DeadlineExceeded means the server may still be writing the file; Canceled and
// Unavailable mean the upload plausibly never happened, so keep those retryable.
export const isTimeoutClassUploadError = (reason: unknown): boolean =>
  reason instanceof ConnectError && reason.code === Code.DeadlineExceeded

/** Server-authored rejections (wrong PDF password) are real copy, shown as-is. */
export const toUploadErrorMessage = (reason: unknown): string => {
  if (reason instanceof ConnectError && reason.code === Code.InvalidArgument) {
    return reason.rawMessage || UPLOAD_GENERIC_FAILURE_MESSAGE
  }
  if (isTimeoutClassUploadError(reason)) {
    return UPLOAD_STILL_PROCESSING_MESSAGE
  }
  return UPLOAD_GENERIC_FAILURE_MESSAGE
}
